<button class="stepper-action stepper-decrement" type="button" tabindex="-1" aria-label="Decrease" [disabled]="$decrementDisabled()" (click)="onStep(-1)">
  <i class="fa-solid fa-minus"></i>
</button>
<span class="stepper-value" role="spinbutton" tabindex="0" [attr.aria-label]="$label()" [attr.aria-valuenow]="$value()" [attr.aria-valuemin]="$min()" [attr.aria-valuemax]="$max()" [attr.aria-disabled]="$disabled()">{{ $value() }}</span>
<button class="stepper-action stepper-increment" type="button" tabindex="-1" aria-label="Increase" [disabled]="$incrementDisabled()" (click)="onStep(1)">
  <i class="fa-solid fa-plus"></i>
</button>
